// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wt_a bih_b bih_we"};